import { render, staticRenderFns } from "./FaqPage.vue?vue&type=template&id=1c12e734&scoped=true"
import script from "./FaqPage.vue?vue&type=script&lang=ts"
export * from "./FaqPage.vue?vue&type=script&lang=ts"
import style0 from "./FaqPage.vue?vue&type=style&index=0&id=1c12e734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12e734",
  null
  
)

export default component.exports